"use client";

import { Box, Button, alpha, lighten, styled } from "@mui/material";

const PagingButton = styled(Button)(({ theme }) => ({
  borderRadius: "5px",
  height: "32px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,

  "&:hover": {
    backgroundColor: lighten(theme.palette.primary.main, 0.2),
  },
}));

const PageNumberButton = styled(Button)(({ theme }) => ({
  width: "32px",
  height: "32px",
  borderRadius: "5px",
  backgroundColor: alpha(theme.palette.primary.light, 0.2),
  color: theme.palette.primary.main,
  padding: 0,
  minWidth: "unset",

  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.4),
  },

  "&:disabled": {
    backgroundColor: "white",
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,

    "&:hover": {
      backgroundColor: "white",
    },
  },
}));

export default function Paging({ page, lastPage, setPage, hasMore }) {
  const isFirstPage = page === 1;
  const maxPagesToShow = 5;
  const pagesToShow = lastPage === 1 ? 0 : Math.min(lastPage, maxPagesToShow);
  let startPage = Math.max(1, page - Math.floor(maxPagesToShow / 2));
  startPage = Math.min(startPage, Math.max(1, lastPage - maxPagesToShow + 1));

  const handleNext = () => {
    setPage((page) => page + 1);
  };

  const handlePrevious = () => {
    setPage((page) => page - 1);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "4px", mt: 5 }}>
      {!isFirstPage && <PagingButton onClick={handlePrevious}>Previous</PagingButton>}
      {Array.from({ length: pagesToShow }, (_, i) => i + startPage).map((pageNumber) => (
        <PageNumberButton
          key={pageNumber}
          onClick={() => setPage(pageNumber)}
          disabled={page === pageNumber}
        >
          {pageNumber}
        </PageNumberButton>
      ))}
      {page !== lastPage && (
        <PagingButton disabled={!hasMore} onClick={handleNext}>
          Next
        </PagingButton>
      )}
    </Box>
  );
}